class SmartSearch extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-ss-scroll]');
            if (!button) return;
            const list = button.closest('.smart-search__products')?.querySelector('.smart-search__products-list');
            if (list) list.scrollBy({ left: list.clientWidth * Number(button.dataset.ssScroll), behavior: 'smooth' });
        });
        this.addEventListener('scroll', (event) => {
            if (event.target.classList?.contains('smart-search__products-list')) this.updateNav();
        }, true);
        window.addEventListener('resize', () => this.updateNav());
        new MutationObserver(() => this.updateNav()).observe(this, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
        this.drawer = document.querySelector(`[data-smart-search="${this.id}"]`);
        this.body = this.querySelector('.smart-search__body');

        if (this.drawer) {
            this.searchButtons = this.querySelectorAll('.search-button');
            this.searchInput = this.querySelector('input[type="text"]');
            this.clearButton = this.querySelector('.clear-button');

            if (!this.searchInput) return;


            this.onInputListener();

            if (this.searchButtons.length && this.searchInput) {
                this.searchSubmitListener();
            }
            this.openHandleInitialization();

            if (!this.clearButton) return;
            this.clearButton.addEventListener('click', () => {
                this.searchInput.value = '';
                this.searchInput.dispatchEvent(new Event('input'));
            });
        }
    }

    openHandleInitialization() {
        window.addEventListener('click', (event) => {
            if (event.target.closest('.search-close-button')) {
                event.preventDefault();
                this.removeAttribute('open');
                return;
            }
            const drawerTarget =
                event.target.closest(`[data-smart-search=${this.id}]`) ||
                event.target.getAttribute('data-smart-search') === this.id;

            if (event.target == this) {
                this.removeAttribute('open');
            }
            else if (drawerTarget) {
                this.open();
            }
        })
    }

    updateNav() {
        this.querySelectorAll('.smart-search__products').forEach((products) => {
            const list = products.querySelector('.smart-search__products-list');
            const nav = products.querySelector('.smart-search__nav');
            if (!list || !nav) return;
            const max = list.scrollWidth - list.clientWidth;
            nav.hidden = max <= 2;
            const [prev, next] = nav.querySelectorAll('[data-ss-scroll]');
            prev.disabled = list.scrollLeft <= 2;
            next.disabled = list.scrollLeft >= max - 2;
        });
    }

    open() {
        this.setAttribute('open', true);
        requestAnimationFrame(() => this.searchInput.focus());
    }

    onInputListener() {
        let timeoutId = null;
        this.searchInput.addEventListener('input', (event) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const query = event.target.value;
                const url = query !== ''
                    ? `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&section_id=smart-search`
                    : `/?section_id=smart-search`;
                this.renderFromURL(url);
            }, 500);
        })
    }

    renderFromURL(url) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(url, { signal: this.abortController.signal })
            .then(data => {
                return data.text();
            })
            .then(data => {
                const html = new DOMParser().parseFromString(data, 'text/html');
                const smartSearchContent = html.querySelector('.smart-search__body');
                if (smartSearchContent && this.body) {
                    this.body.className = smartSearchContent.className;
                    this.body.innerHTML = smartSearchContent.innerHTML;
                }
            })
            .catch(error => {
                if (error.name !== 'AbortError') throw error;
            });
    }

    submitSearch() {
        const query = this.searchInput.value;
        if (query !== '') {
            window.location.assign(`/search?q=${encodeURIComponent(query)}&type=product`);
        }
    }

    searchSubmitListener() {
        this.searchButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                this.submitSearch();
            });
        })
        const keyListener = (event) => {
            if (event.key === 'Enter') {
                this.submitSearch();
            }
        }
        this.searchInput.addEventListener('focusin', () => {
            window.addEventListener('keyup', keyListener);
        });
        this.searchInput.addEventListener('focusout', () => {
            window.removeEventListener('keyup', keyListener);
        });
    }
}

customElements.define('smart-search', SmartSearch);